import React from 'react';
import { Link } from '@reach/router';

import './style.scss';

// import island from '../../assets/img/island.png';
import map from './fimap@2x.png';

const Island = () => (
  <div className="map-container">
    <div className="direction west">
      <i className="fas fa-arrow-alt-circle-left" /> West
    </div>
    <div className="direction east">
      East <i className="fas fa-arrow-alt-circle-right" />
    </div>
    <div className="map-box table-wrap">
      {/* <h1>Fire Island</h1> */}
      {/* <h2>Where will your adventure take you?</h2> */}
      {/* <div className="island" dangerouslySetInnerHTML={{ __html: map }} /> */}
      <div className="island-box">
        <div className="island-water" />
        {/* <div className="island-image" style={{ backgroundImage: `url(${map})` }}>
          <div className="island-water" />
        </div> */}
        <img className="island-image" alt="Fire Island" src={map} />
        <Link className="beach-link selected" style={{ left: '84px' }} to="/communities/fi-lighthouse/" />
        <Link className="beach-link" style={{ left: '128px' }} to="/communities/kismet/" />
        <Link className="beach-link" style={{ left: '170px' }} to="/communities/saltaire/" />
        <Link className="beach-link" style={{ left: '223px' }} to="/communities/fair-harbor/" />
        <Link className="beach-link" style={{ left: '257px' }} to="/communities/dunewood/" />
        <Link className="beach-link" style={{ left: '316px' }} to="/communities/atlantique/" />
        <Link className="beach-link" style={{ left: '388px' }} to="/communities/ocean-beach/" />
        <Link className="beach-link" style={{ left: '419px' }} to="/communities/seaview/" />
        <Link className="beach-link" style={{ left: '489px' }} to="/communities/ocean-bay-park/" />
        <Link className="beach-link" style={{ left: '529px' }} to="/communities/point-o-woods/" />
        <Link className="beach-link" style={{ left: '632px' }} to="/communities/sailors-haven-sunken-forest/" />
        <Link className="beach-link" style={{ left: '662px' }} to="/communities/sailors-haven-sunken-forest/" />
        <Link className="beach-link" style={{ left: '750px' }} to="/communities/cherry-grove/" />
        <Link className="beach-link" style={{ left: '836px' }} to="/communities/fi-pines/" />
        <Link className="beach-link" style={{ left: '1145px' }} to="/communities/water-island/" />
        <Link className="beach-link" style={{ left: '1197px' }} to="/communities/davis-park/" />
        <Link className="beach-link" style={{ left: '1315px' }} to="/communities/watch-hill/" />

      </div>
    </div>
  </div>
);

export default Island;
